export const PersonIcon = ({ theme }: { theme: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0002 9.99992C11.8446 9.99992 13.3335 8.51103 13.3335 6.66659C13.3335 4.82214 11.8446 3.33325 10.0002 3.33325C8.15572 3.33325 6.66683 4.82214 6.66683 6.66659C6.66683 8.51103 8.15572 9.99992 10.0002 9.99992ZM10.0002 11.6666C7.77794 11.6666 3.3335 13.008 3.3335 15.4471V16.2499C3.3335 16.48 3.52004 16.6666 3.75016 16.6666H16.2502C16.4803 16.6666 16.6668 16.48 16.6668 16.2499V15.4471C16.6668 13.008 12.2224 11.6666 10.0002 11.6666Z"
        fill={theme === 'light' ? '#343434' : '#FFFFFF'}
      />
    </svg>
  );
};
